'use strict';
var processInclude = require('base/util');

processInclude(require('./components/configuratorCard'));
processInclude(require('./components/form'));
processInclude(require('./vendors/slick/slickCarousel'));
processInclude(require('./vendors/jquery-ui/jquery-ui.js'));
processInclude(require('../utils/imageLazyLoad.js'));
processInclude(require('./globalECUX.js'));

require('./vendors/bootstrap-5.3/offcanvas');
